'use client';
import * as Sentry from '@sentry/react';
import Cookies from 'js-cookie';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { getCleanUrl, getParamsToStore } from '../helpers';
import { useTrackingUserParamsStore } from '../store';
import { pushStag } from '@/api/common';

export const USER_TRACKING_PARAMS_SS = [
  'stag', // contains affiliateID_visitorID
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'ref_code',
];

/**
 * Hook to manage user tracking parameters in the URL for SoftSwiss.
 */
export const useTrackingUserParamsHook = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const setParams = useTrackingUserParamsStore(
    (state) => state.setTrackingUserParams
  );

  const isActiveSession = Cookies.get('active_session') === 'true';
  const isRegistered = Cookies.get('is_registered') === 'true';
  const isAuth = isActiveSession || isRegistered;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.size === 0) return;

    const paramsToStore: Record<string, unknown> = getParamsToStore(
      params,
      USER_TRACKING_PARAMS_SS
    );
    if (Object.keys(paramsToStore).length === 0) return;

    if (!isAuth) {
      Cookies.set('tracking-user-params', JSON.stringify(paramsToStore));
      setParams(paramsToStore);
      pushStag(paramsToStore).catch((error) =>
        Sentry.captureException(
          error || new Error('Sending tracking params to SS error')
        )
      );
    }

    router.replace(getCleanUrl(params), { scroll: false });
  }, [searchParams, router, setParams, isAuth]);
};
